/**
 * Throws when API body signals failure despite HTTP 200.
 * @param {unknown} data
 * @returns {unknown}
 */
export function assertProjectApiSuccess(data) {
  if (data?.Message === 'fail' || data?.Token === 'fail') {
    const err = new Error(data?.Message || 'Request failed');
    err.response = { data };
    throw err;
  }
  return data;
}
